<button type="button"
    class="btn btn-sm"
    [ngClass]="getStatusClass()"
    (click)="startSession()">
    {{ getName() }}
</button>
